<div id="{{anchorValue}}" class="overview-product--grid">

	@if (showProduct) {
	<a (click)="viewProductDetail()"
	   [description]="getImageAltTitle()"
	   [imageFormat]="182"
	   [image]="largeImage"
	   [titleDescription]="product.totalDescription1"
	   class="overview-product_image"
	   render-product-image>
	</a>
	}

	<div class="product-title__wrapper">
		@if (showProduct) {
		<h2 class="overview-product_title">
			<a (click)="viewProductDetail()">
				{{product.totalDescription1}}
			</a>

			@if (product.totalDescription2.trim().length > 0) {
			<div class="overview-product_subtitle">
				{{product.totalDescription2}}
			</div>
			}
		</h2>
		}

		@if (loggedIn) {
		<productitem-favorite [product]="product"></productitem-favorite>
		}
	</div>

	@if (showProduct) {
	<div class="overview-product_info">
		<product-size [componentHeight]="productSizeComponentHeight()"
		              [height]="product.potHeight" [potSize]="product.potSize">
		</product-size>

		@if (loggedIn) {
		<div class="overview-product_price">
			@if (product.available) {
			<span class="overview-product_price--from">
              <ng-container i18n="@@product.price.from">From</ng-container>
				<!-- only show when there's a discount -->
              @if (product.saleDiscount > 0) {
                <span class="original-price">{{userCurrency}} {{ productPrices.getOriginalPriceForProductType() | numberFormat:true }}
                  <br></span>
                }
              </span>
			<!-- product price, no discount -->
			<strong>
				@if (product.saleDiscount > 0) {
				<span
						class="discount-tag theme-success-color">-{{product.saleDiscount}}%</span>
				}
				{{userCurrency}} {{ productPrices.getCheapestAvailablePrice() | numberFormat:true }}
			</strong>
			} @else {
			<strong class="price-unavailable"
			        i18n="Not available text in product tile view@@productitem.grid.currently.unavailable">
				Currently unavailable
			</strong>
			}
		</div>
		}
	</div>
	}

	<div class="overview-product__add_placeholder">
		@if (showProduct) {
		@if (product.isStockProduct) {
		<div class="overview-product_info">
			<div class="overview-product_message">
				@if (product.qtyByBox == 1) {
				<span class="text-green-notice theme-success-text-color"
				        i18n="@@product.quantity.stock.unit">

					{{getAvailableQuantity()}} x{{product.qtyByBox}} available
				</span>
				}

				@if (product.qtyByBox > 1) {
				<span class="text-green-notice theme-success-text-color"
				        i18n="@@product.quantity.stock.tray">

					{{getAvailableQuantity()}} x{{product.qtyByBox}} available
				</span>
				}
			</div>
		</div>
		}

		<!-- When in a grid row there is a stock type then show an empty line to lineup pricing -->
		@if (!product.isStockProduct && gridRowHasStockTypes) {
		<div class="overview-product_info">
			<div class="overview-product_message">
				<strong class="text-green-notice theme-success-text-color">
					<pre style="margin: unset"> </pre>
				</strong>
			</div>
		</div>
		}

		@if (!productPrices.showBoxOption()) {
		<div class="overview-product_add overview-product_not-available">
			<strong i18n="Not available text in product tile view@@productitem.grid.currently.unavailable">
				Currently unavailable
			</strong>
		</div>
		}

		<product-more-available [product]="product" class="overview-product_more-available"></product-more-available>

		@if (productPrices.showBoxOption()) {
		<form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
			@if (product.available && loggedIn) {
			<div class="overview-product_add">
				@if (!product.isStockProduct) {
				<input (blur)="changeQuantity()"
				       [formControl]="form.controls['numberOfUnits']"
				       autocomplete="off"
				       class="numberOfUnits"
				       i18n-title="@@minimum.order.quantity"
				       max="{{maxValue}}"
				       min="{{minimumOrderQuantity}}"
				       name="numberOfUnits"
				       required
				       title="The minimum order quantity is {{minimumOrderQuantity}} x {{itemsPerUnit}}"
				       type="number" />
				}

				@if (product.isStockProduct) {
				<input (blur)="changeQuantity()"
				       [formControl]="form.controls['numberOfUnits']"
				       autocomplete="off"
				       class="numberOfUnits"
				       i18n-title="@@minimum.and.maximum.order.quantity"
				       max="{{maxValue}}"
				       min="{{minimumOrderQuantity}}"
				       name="numberOfUnits"
				       required
				       title="The minimum order quantity is {{minimumOrderQuantity}} x {{itemsPerUnit}}. The maximum order quantity is {{maxValue}} x {{itemsPerUnitMax}}"
				       type="number" />
				}

				<div class="custom-select">
					<ng-select id="unit"
					           name="unit"
					           class="custom-ng-select"
					           (change)="onSelectedUnitChange($event)"
					           [items]="availableUnitOptions"
					           bindValue="value"
					           [multiple]="false"
					           [clearable]="false"
					           [markFirst]="true"
					           [searchable]="false"
					           [formControl]="form.controls['unit']">

						<ng-template ng-label-tmp let-item="item">
							<div class="select-label">
                                <span class="option-quantity">x{{item.qty}}&nbsp;@if (item.qtyBox) {
                                    <span>x{{item.qtyBox}}</span>}
                                </span>
								<span class="option-price">{{item.price | numberFormat: true }}</span>
							</div>
						</ng-template>

						<ng-template ng-option-tmp let-item="item" let-index="index">
							<div class="select-label">
                                <span class="option-quantity">
	                                x{{item.qty}}&nbsp;@if (item.qtyBox) {<span>x{{item.qtyBox}}</span>}
                                </span>
								<span class="option-price">{{item.price | numberFormat: true }}</span>
							</div>
						</ng-template>
					</ng-select>
				</div>
			</div>
			}

			@if (!product.available && loggedIn) {
			<div class="overview-product_add more-information">
				<strong i18n="Not available text in product tile view@@productitem.grid.currently.unavailable">
					Currently unavailable
				</strong>
			</div>
			}

			@if (product.available && loggedIn) {
			<div class="overview-product_button">
				<button type="submit"
				        [attr.disabled]="isEnabled() ? null : 'disabled'"
				        [ngClass]="{'button theme-btn-secondary': true, 'button--product-added': buttonShowPressed}">
					@if (!showConfirmation) {
					<strong>
						@if (!useFastCheckout) {
						<ng-container i18n="@@add.to.cart.button">
							Add to cart
						</ng-container>
						}
						@if (useFastCheckout) {
						<ng-container i18n="@@buy.now.button">
							Buy now
						</ng-container>
						}
					</strong>

					@if (!buttonShowPressed) {
					<render-checkout-icon [iconWidth]="31" [iconHeight]="16"
					                      [fastCheckout]="useFastCheckout">
					</render-checkout-icon>
					}

					@if (buttonShowPressed) {
					<svg class="icon-spinner" width="14" height="14">
						<use xlink:href="/images/icons/svg-sprite.svg#spinner"></use>
					</svg>
					}
					}

					@if (showConfirmation) {
					<svg class="icon-check" width="16" height="14">
						<use xlink:href="/images/icons/svg-sprite.svg#check"></use>
					</svg>

					<strong i18n="Label shown after products were added@@buy.options.products.added">
						Products added
					</strong>
					}
				</button>
			</div>
			}

			@if (!product.available && loggedIn) {
			<div class="overview-product_button">
				<a (click)="viewProductDetail()" class="button theme-btn-secondary"
				   i18n="Label shown on the more info button if user is not logged in@@product.more.info">
					More info
				</a>
			</div>
			}

			@if (!loggedIn) {
			<div class="overview-product_button">
				<a (click)="viewProductDetail()" class="button theme-btn-secondary"
				   i18n="Label shown on the more info button if user is not logged in@@product.more.info">
					More info
				</a>
			</div>
			}
		</form>
		}
		}
	</div>
</div>
